// Deploy-agnostic "is there a newer build" signal for the installed PWA and
// long-lived browser tabs. public/version.json gets a fresh buildId on every
// `npm run build` (scripts/generate-version.js) and nginx serves it no-cache
// like index.html, so comparing it to the buildId this page loaded with
// reliably detects a new deploy — unlike the service worker, which stays
// byte-identical across ordinary JS/CSS-only deploys and would never notice.
let initialBuildId = null;

async function fetchBuildId() {
    const res = await fetch('/version.json', { cache: 'no-store' });
    if (!res.ok) throw new Error(`version.json request failed: ${res.status}`);
    const data = await res.json();
    return data.buildId;
}

// Call once, as early as possible, so later checks have something to diff against.
export async function captureInitialVersion() {
    try {
        initialBuildId = await fetchBuildId();
    } catch (err) {
        // Offline or a transient failure at startup — checks below simply
        // stay inert until a later call succeeds and sets a baseline.
    }
}

export async function isNewVersionAvailable() {
    if (!initialBuildId) {
        await captureInitialVersion();
        return false;
    }
    try {
        const current = await fetchBuildId();
        return current !== initialBuildId;
    } catch (err) {
        return false;
    }
}
